import AxiosInstance from "axios";
import Cookies from "js-cookie";

import { API_V1_BASE_URL, BASE_URL } from "utils/constants";

const axios = AxiosInstance.create({
  baseURL: API_V1_BASE_URL,
  withCredentials: true,
  headers: {
    Accept: "application/json",
  }
});

// Request interceptor. Runs before your request reaches the server
const onRequest = (config) => {
  // Let browser set multipart boundary automatically for FormData payloads.
  if (
    typeof FormData !== "undefined" &&
    config.data instanceof FormData &&
    config.headers
  ) {
    delete config.headers["Content-Type"];
  }

  // Add XSRF token to headers if it exists
  const token = Cookies.get("XSRF-TOKEN");
  if (token) {
    config.headers["X-XSRF-TOKEN"] = decodeURIComponent(token);
  }

  // If http method is `post | put | delete` and XSRF-TOKEN cookie is
  // not present, call '/sanctum/csrf-cookie' to set CSRF token, then
  // proceed with the initial request
  if (
    (config.method === "post" ||
      config.method === "put" ||
      config.method === "delete") &&
    !token
  ) {
    return setCSRFToken().then(() => {
      // After getting CSRF token, add it to headers
      const newToken = Cookies.get("XSRF-TOKEN");
      if (newToken) {
        config.headers["X-XSRF-TOKEN"] = decodeURIComponent(newToken);
      }
      return config;
    });
  }
  return config;
};

// A function that calls '/sanctum/csrf-cookie' to set the CSRF cookies.
const setCSRFToken = () => {
  return AxiosInstance.get(`${BASE_URL}/sanctum/csrf-cookie`, {
    withCredentials: true,
    headers: {
      Accept: "application/json",
    },
  });
};

// attach your interceptor
axios.interceptors.request.use(onRequest, null);

export default axios;
